import React ,{useRef ,useEffect}from 'react';
import moment from 'moment'
import DynamicInputList from '../software-dynamic-version-5/list-input-v-5';
import SecurityService from '../security/security.service';
import { TooltipComponent } from "@syncfusion/ej2-react-popups";

import InvoiceAdd  from './sale-invoice-add'
import SaleInvoiceService from './sale-invoice.service';

import { QRCodeGenerator } from '@syncfusion/ej2-barcode-generator';
import DialogInput from '../software-dynamic-version-5/popup-dialog-input-v-5';
import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import './sale-invoice-list.scss'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import securityService from '../security/security.service';
import ListButtonPopupList from '../software-dynamic-version-6/list-button-popup-list-v-6'
import ImportExcelService from '../import-excel-data-in-table/import-excel.service';

let invoiceDetails={}
const SaleInvoiceInput = (props) => {
;
  useEffect(() => {
    // console.log(localStorage.getItem('ShowSaleChallan') )
    const updateHeadingColor = () => {
      const gridDiv = document.getElementById("SaleInvoiceGrid");
      if (!gridDiv) return;
  
      const siblings = Array.from(gridDiv.parentElement.children);
      const heading = siblings.find(
        el => el.tagName === "H3" && el !== gridDiv
      );
  
      if (!heading) return;
  
      if (props?.path === "/SaleInvoiceSandbox") {
        heading.style.color = "#203b6b";
      } else if (props?.path === "/SaleInvoicePosted") {
        heading.style.color = "green";
      } else {
        heading.style.color = "red";
      }
    };
  
    updateHeadingColor();
  
    const observer = new MutationObserver(updateHeadingColor);
    observer.observe(document.body, { childList: true, subtree: true });
  
    return () => observer.disconnect();
  }, [props?.path]);
  

    let columns = [
      { field: "SaleInvoiceID", headerText: "SOFTWARE ID", width: "90px", textAlign: "right", headerTextAlign: "center", other: [] },
      { field: "invoiceDate", headerText: "Invoice Date", width: "140px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "docDescription", headerText: "Document Description", width: "160px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "ChallanNo", headerText: "REFERENCE NO", width: "160px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "FBRSaleInvoiceDetailNo", headerText: "FBR Sale Invoice", width: "220px", textAlign: "center", headerTextAlign: "center", other: [] },
      { field: "sellerBusinessName", headerText: "Seller Name", width: "200px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "sellerNTNCNIC", headerText: "Seller NTN/CNIC", width: "160px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "sellerProvince", headerText: "Seller Province", width: "140px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "sellerAddress", headerText: "Seller Address", width: "220px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "buyerNTNCNIC", headerText: "Buyer NTN/CNIC", width: "160px", textAlign: "right", headerTextAlign: "center", other: [] },
      { field: "buyerBusinessName", headerText: "Buyer Name", width: "200px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "buyerProvince", headerText: "Buyer Province", width: "140px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "buyerAddress", headerText: "Buyer Address", width: "320px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "buyerRegistrationType", headerText: "Buyer Type", width: "120px", textAlign: "center", headerTextAlign: "center", other: [] },
      { field: "invoiceRefNo", headerText: "Invoice Ref No", width: "140px", textAlign: "right", headerTextAlign: "center", other: [] },
      { field: "scenarioId", headerText: "Scenario ID", width: "140px", textAlign: "right", headerTextAlign: "center", other: [{visible:props?.path == "/SaleInvoiceSandbox"}] },
      { field: "hsCode", headerText: "HS Code", width: "120px", textAlign: "center", headerTextAlign: "center", other: [] },
      { field: "productDescription", headerText: "Product Description", width: "200px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "rate", headerText: "Rate", width: "120px", textAlign: "right", headerTextAlign: "center", other: [] },
      { field: "uoM", headerText: "UOM", width: "100px", textAlign: "center", headerTextAlign: "center", other: [] },
      { field: "quantity", headerText: "Quantity", width: "130px", textAlign: "right", headerTextAlign: "center", other: [{format:'n2'}] },
      // { field: "valueSalesExcludingST", headerText: "Value of Sales Excl. ST", width: "140px", textAlign: "right", headerTextAlign: "center", other: [{format:'n0'}] },
      // BEFORE
// { field: "valueSalesExcludingST", headerText: "Value of Sales Excl. ST", width: "140px", textAlign: "right", headerTextAlign: "center", other: [{format:'n0'}] },

// AFTER
{ field: "valueSalesExcludingST", headerText: "Value of Sales Excl. ST", width: "140px", textAlign: "right", headerTextAlign: "center", other: [{format:'n2'}] },

      { field: "salesTaxApplicable", headerText: "Sales Tax", width: "120px", textAlign: "right", headerTextAlign: "center", other: [{format:'n2'}] },
      { field: "fixedNotifiedValueOrRetailPrice", headerText: "Fixed/Notified Value of Retail Price", width: "140px", textAlign: "right", headerTextAlign: "center", other: [{format:'n0'}] },
      { field: "salesTaxWithheldAtSource", headerText: "ST Withheld At Source", width: "120px", textAlign: "right", headerTextAlign: "center", other: [{format:'n0'}] },
      { field: "extraTax", headerText: "Extra Tax", width: "120px", textAlign: "right", headerTextAlign: "center", other: [{format:'n0'}] },
      { field: "furtherTax", headerText: "Further Tax", width: "120px", textAlign: "right", headerTextAlign: "center", other: [{format:'n0'}] },
      { field: "fedPayable", headerText: "FED Payable", width: "120px", textAlign: "right", headerTextAlign: "center", other: [{format:'n0'}] },
      { field: "discount", headerText: "Discount", width: "120px", textAlign: "right", headerTextAlign: "center", other: [{format:'n0'}] },
      { field: "totalValues", headerText: "Total Value", width: "140px", textAlign: "right", headerTextAlign: "center", other: [{format:'n2'}] },
      { field: "sroScheduleNo", headerText: "SRO Schedule No", width: "140px", textAlign: "center", headerTextAlign: "center", other: [] },
      { field: "sroItemSerialNo", headerText: "SRO Item Serial No", width: "140px", textAlign: "center", headerTextAlign: "center", other: [] },
      { field: "saleType", headerText: "Sale Type", width: "250px", textAlign: "center", headerTextAlign: "center", other: [] },
    ];

        const getDetail = (data) =>{
          invoiceDetails = data
        }

        const listActionComplete = async (
          grid,
          args,
          getListService,
          selectedRow,
          setDataSourceState,
          addUserLog,
          editUserLog
        ) => {
          console.log(args);
          console.log(getListService);
          console.log(selectedRow);
        
          if (args.requestType === 'beginEdit' || args.requestType === 'add') {
          }
        
          if (args.requestType === 'save' || args.requestType === 'cancel') {
            getListService();
          }
        
          if (args.requestType === 'save') {
            console.log(invoiceDetails);
        
            const newInvoiceDetails = {
              ...invoiceDetails,
              items: invoiceDetails.items.map(({ HSCodeDetail, ...rest }) => rest),
            };
            
            let validateResponse =  props?.path == "/SaleInvoiceSandbox"  ? await SaleInvoiceService.validatePostDataTesting(
              args.data.CompanyID,
              newInvoiceDetails
            )   : await SaleInvoiceService.validatePostData(
              args.data.CompanyID,
              newInvoiceDetails
            );
            console.log(validateResponse);
        
            if (args.action === 'add' && validateResponse?.data?.validationResponse?.invoiceStatuses[0].status == "Valid") {
              const mainData = {
                docDescription: invoiceDetails.invoiceType,
                invoiceDate: invoiceDetails.invoiceDate,
                sellerNTNCNIC: invoiceDetails.sellerNTNCNIC,
                buyerNTNCNIC: invoiceDetails.buyerNTNCNIC,
                invoiceRefNo: args.data.invoiceRefNo || '',
                scenarioId: invoiceDetails.scenarioId,
                ChallanNo:args.data.ChallanNo || '',
                MainInvoiceID:args.data.MainInvoiceID || '',
                SaleInvoiceJSON: JSON.stringify(newInvoiceDetails),
              };
        
              const detailItems = invoiceDetails.items.map((item) => ({
                hS_CODE: item.hsCode,
                HSCodeDetail: item.HSCodeDetail,
                productDescription: item.productDescription,
                rate: item.rate,
                uoM: item.uoM,
                quantity: item.quantity,
                totalValues: item.totalValues,
                valueSalesExcludingST: item.valueSalesExcludingST,
                fixedNotifiedValueOrRetailPrice: item.fixedNotifiedValueOrRetailPrice,
                salesTaxApplicable: item.salesTaxApplicable,
                salesTaxWithheldAtSource: item.salesTaxWithheldAtSource,
                extraTax: item.extraTax,
                furtherTax: item.furtherTax,
                sroScheduleNo: item.sroScheduleNo,
                fedPayable: item.fedPayable,
                discount: item.discount,
                transactioN_Desc: item.saleType,
                sroItemSerialNo: item.sroItemSerialNo,
                AdvanceIncomeTaxPercent: item.AdvanceIncomeTaxPercent || 0,
                AdvanceIncomeTaxAmount: item.AdvanceIncomeTaxAmount || 0,
              }));
        
              const dataToInsert = {
                 ...mainData,
                details: detailItems,
              };
        
              try {
                const insertResponse = await SaleInvoiceService.insert(dataToInsert);
                console.log('Insert response:', insertResponse);
                getListService();
              } catch (error) {
                console.error('Insert failed:', error);
              }
            }
          }
        };

    let  allowTemplate = true
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = true
    let  allowGridSum = true
    let  isDialog = props.IsDialog == true ? true : false

        let ListSecurity= props?.path == "/SaleInvoiceSandbox" ? `Sale Invoice Sandbox` :`Sale Invoice`
        let AddSecurity= props?.path == "/SaleInvoiceSandbox" ? `Sale Invoice Sandbox` :`Sale Invoice`
        let EditSecurity= props?.path == "/SaleInvoiceSandbox" ? `Sale Invoice Sandbox` :`Sale Invoice`
        let DeleteSecurity= props?.path == "/SaleInvoiceSandbox" ? `Sale Invoice Sandbox` :`Sale Invoice`

      let toolbarOptions = [
        {
          text: " Add Invoice For FBR", tooltipText: "Add Invoice For FBR", id: "Add", disabled:false
        },
        'Edit',
        {
          text: "delete", tooltipText: "Delete Row", id: "RowDelete", disabled:!DeleteSecurity,
          prefixIcon: "e-icons e-delete"
        },
        {
          text: "Post Data", tooltipText: "Post Data", id: "PostData", disabled:false
        },
        {
          text: "Import Excel",
          tooltipText: "Import Excel",
          id: "ImportExcelList",
          prefixIcon: "e-importexcel",
          cssClass: "e-importexcel",
          disabled: false
        },
        {
          text: "Preview A", tooltipText: "Sale Invoice Preview", id: "SaleInvoicePreview", disabled:false, prefixIcon: "e-icons e-view"
        },
        {
          text: "Preview B", tooltipText: "Sale Invoice Preview B", id: "SaleInvoicePreview2", disabled:false, prefixIcon: "e-icons e-view"
        },
        // ✅ NEW — Preview E button
        {
          text: "Preview E", tooltipText: "Sale Invoice Preview E", id: "SaleInvoicePreviewE", disabled:false, prefixIcon: "e-icons e-view"
        },
       
        'PDFExport','ExcelExport',
        'Search','ColumnChooser'
      ];

      let PostedToolbarOptions = [
        {
          text: "Preview A", tooltipText: "Sale Invoice Preview", id: "SaleInvoicePreview", disabled:false, prefixIcon: "e-icons e-view"
        },
        {
          text: "Preview B", tooltipText: "Sale Invoice Preview B", id: "SaleInvoicePreview2", disabled:false, prefixIcon: "e-icons e-view"
        },
        // ✅ NEW — Preview E button (Posted toolbar mein bhi)
        {
          text: "Preview E", tooltipText: "Sale Invoice Preview ETT", id: "SaleInvoicePreviewE", disabled:false, prefixIcon: "e-icons e-view"
        },
        'PDFExport','ExcelExport','Search','ColumnChooser'
      ];

   //  ===== GENERATING QR CODE ======
        function generateQRCodeBlob(value) {
          return new Promise((resolve) => {
            const container = document.createElement('div');
            container.style.position = 'absolute';
            container.style.left = '-9999px';
            container.style.width = '96px';
            container.style.height = '96px';
            document.body.appendChild(container);
        
            const qrCode = new QRCodeGenerator({
              width: '96px',
              height: '96px',
              value: value,
              mode: 'Canvas',
              backgroundColor: 'transparent',
              version: 2,
              displayText: { visibility: false },
              margin: { left: 0, right: 0, top: 0, bottom: 0 }
            });
        
            qrCode.appendTo(container);
        
            setTimeout(() => {
              const canvas = container.querySelector('canvas');
              if (canvas) {
                const jpegCanvas = document.createElement('canvas');
                jpegCanvas.width = canvas.width;
                jpegCanvas.height = canvas.height;
                const ctx = jpegCanvas.getContext('2d');
        
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, jpegCanvas.width, jpegCanvas.height);
                ctx.drawImage(canvas, 0, 0);
        
                jpegCanvas.toBlob((blob) => {
                  container.remove();
                  resolve(blob);
                }, 'image/jpeg', 1.0);
              } else {
                container.remove();
                resolve(null);
              }
            }, 150);
          });
        }

        function convertNumberToWords(num) {
  const units = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
    "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];
  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy",
    "Eighty", "Ninety"
  ];
  const scales = [
    { value: 10000000, name: "Crore" },
    { value: 100000, name: "Lakh" },
    { value: 1000, name: "Thousand" },
    { value: 100, name: "Hundred" }
  ];

  function numberToWords(n) {
    if (n === 0) return "Zero";
    if (n < 20) return units[n];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " " + units[n % 10] : "");

    for (let scale of scales) {
      if (n >= scale.value) {
        const quotient = Math.floor(n / scale.value);
        const remainder = n % scale.value;
        return (
          numberToWords(quotient) +
          " " +
          scale.name +
          (remainder ? " " + numberToWords(remainder) : "")
        );
      }
    }
    return "";
  }

  const whole = Math.floor(num);
  const fraction = Math.round((num - whole) * 100);

  let result = numberToWords(whole) + " Rupees";
  result += " and " + numberToWords(fraction) + " Paise";

  return result;
}

  const base64ToBlob = (base64) => {
    const clean = base64.includes(",") ? base64.split(",")[1] : base64;
    const mime = base64.match(/data:(.*?);base64/)?.[1] || "image/png";
  
    const binary = atob(clean);
    const bytes = new Uint8Array(binary.length);
  
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
  
    return new Blob([bytes], { type: mime });
  };
  
  const getSellerLogo = async (CompanyNTNCNIC) => {
    const storedLogo = securityService.getCompanyImage();
  
    if (storedLogo && !storedLogo.includes("placehold")) {
      return base64ToBlob(storedLogo);
    }
  
    const response = await securityService.getCompanyLogo(CompanyNTNCNIC);
    const logo = response?.data?.logo;
    console.log(logo)
  
    if (!logo || logo.includes("placehold")) {
      return null;
    }
  
    return base64ToBlob(logo);
  };
  
  let  getFormattedInvoiceRecords = async (id ,previewType) => {
    let response = await SaleInvoiceService.getSaleInvoiceForList(id ,props?.path == "/SaleInvoiceSandbox" ? 0:1);
      const invoices = response.data.recordset;
  console.log(invoices)
      if (!invoices || invoices.length === 0) {
        console.log("No invoice data found.");
        return null;
      }
      
      let totalvalueSalesExcludingST = 0;
      let totalValues = 0;
      let totalGrandTotal = 0;
      let totalSalesTax = 0;
      let totalFurtherTax = 0;
      let totalExtraTax = 0;
      let totalFedPayable = 0;
      let totalDiscount = 0;
      let totalQuantity = 0;
      let totalfixedNotifiedValueOrRetailPrice = 0;
      let totaladvanceIncomeTaxAmount = 0;
  
      const invoiceItems = invoices.map((item, idx) => {
        console.log(item);
        // const itemTotal = previewType == 'B'? item?.totalValues || 0 :item?.ShowAdvanceIncomeTax == 1 || item?.ShowAdvanceIncomeTax  == true  ? (item.totalValues || 0) + (item?.AdvanceIncomeTaxAmount || 0) : item.totalValues || 0;
        const grandTotal =
  (item?.totalValues || 0) +
  (previewType !== 'B' && item?.ShowAdvanceIncomeTax
    ? (item?.AdvanceIncomeTaxAmount || 0)
    : 0);
        const itemTotal =(item?.totalValues || 0);
        const itemSalesTax = item.salesTaxApplicable || 0;
        const itemFurtherTax = item.furtherTax || 0;
        const itemExtraTax = Number(item.extraTax) || 0;
        const itemFedPayable = item.fedPayable || 0;
        const itemDiscount = item.discount || 0;
        const valueSalesExcludingST = item.valueSalesExcludingST || 0;
        const itemQuantity = item?.quantity || 0;
        const fixedNotifiedValueOrRetailPrice = item?.fixedNotifiedValueOrRetailPrice || 0;
        const advanceIncomeTaxAmount = item?.AdvanceIncomeTaxAmount || 0;
        
  
        totalvalueSalesExcludingST += valueSalesExcludingST;
        totalValues += itemTotal;
        totalGrandTotal += grandTotal;
        totalSalesTax += itemSalesTax;
        totalFurtherTax += itemFurtherTax;
        totalExtraTax += Number(itemExtraTax);
        totalFedPayable += itemFedPayable;
        totalDiscount += itemDiscount;
        totalQuantity += itemQuantity;
        totalfixedNotifiedValueOrRetailPrice += fixedNotifiedValueOrRetailPrice;
        totaladvanceIncomeTaxAmount += advanceIncomeTaxAmount;
  
        return {
          srNo: idx + 1,
          FBRSaleInvoiceDetailNo: item.FBRSaleInvoiceDetailNo || 'INVOICE NOT POSTED TO FBR',
          description: item.productDescription,
          hsCode: item.hsCode,
          uoM: item?.uoM,
          quantity: itemQuantity,
          rate: item.rate,
          salesTax: itemSalesTax,
          extraTax: itemExtraTax,
          furtherTax: itemFurtherTax,
          fed: itemFedPayable,
          discount: itemDiscount,
          amount:valueSalesExcludingST ,
          totalInclTax: itemTotal,
          fixedNotifiedValueOrRetailPrice:fixedNotifiedValueOrRetailPrice
        };
      });
  
      const invoice = invoices[0];
      let Logo = await getSellerLogo(invoice.sellerNTNCNIC);

      const amountIsVisible              = totalvalueSalesExcludingST !== 0;
      const salesTaxsVisible             = totalSalesTax !== 0;
      const extraTaxsVisible             = totalExtraTax !== 0;
      const furtherTaxsVisible           = totalFurtherTax !== 0;
      const fedsVisible                  = totalFedPayable !== 0;
      const discountsVisible             = totalDiscount !== 0;
      const totalInclTaxsVisible         = totalValues !== 0;

      const invoiceDetails = {
        ...invoice,
        SaleInvoiceID: id || invoice.SaleInvoiceID,
        invoiceNo: invoice.FBRSaleInvoiceNo || "INVOICE NOT POSTED TO FBR",
        date: invoice.invoiceDate,
        docDescription:invoice?.docDescription,
        buyerName: invoice.buyerBusinessName,
        buyerCompany: invoice.buyerBusinessName,
        buyerRegion: invoice.buyerProvince,
        buyerSTRN: invoice.buyerSTRN,
        buyerNTN: invoice.buyerNTNCNIC && invoice.buyerNTNCNIC.length  == 13 ? invoice.buyerNTNCNIC :invoice?.buyerNTNCNICReferenceNo,
        buyerType: invoice.buyerRegistrationType,
        sellerName: invoice.sellerBusinessName,
        buyerAddress: invoice.buyerAddress,
        sellerCompany: invoice.sellerBusinessName,
        sellerLogo:Logo || null,
        sellerAddress: invoice.sellerAddress,
        SellerRemarks: invoice.SellerRemarks || '',
        sellerNTN: invoice.sellerNTNCNIC,
        sellerNTNCNICReferenceNo: invoice.sellerNTNCNICReferenceNo,
        sellerRegion: invoice.sellerProvince,
        sellerType: invoice?.sellerRegistrationType,
        saleType: invoice?.saleType,
        subTotal: totalvalueSalesExcludingST,
        salesTax: totalSalesTax,
        furtherTax: totalFurtherTax,
        extraTax: totalExtraTax,
        fedPayable: totalFedPayable, 
        discount: totalDiscount,
        quantity: totalQuantity,
        TotalAdvanceIncomeTaxAmount:totaladvanceIncomeTaxAmount,
        fixedNotifiedValueOrRetailPrice: totalfixedNotifiedValueOrRetailPrice,
        grandTotal:totalGrandTotal,
        
        grandTotalInWords: convertNumberToWords(totalGrandTotal.toFixed(2)) + " Only",
        amountIsVisible,
        salesTaxsVisible,
        extraTaxsVisible,
        furtherTaxsVisible,
        fedsVisible,
        discountsVisible,
        totalInclTaxsVisible,
        buyerNTNCNICReferenceNo:invoice?.buyerNTNCNICReferenceNo
      };
  
      return {
        invoiceDetails,
        invoiceItems
      };
  }

        // ==================== PREVIEW A =======================
        const handleRedirectContractPreview = async (row) => {
          console.log(row);
          
          const records = await getFormattedInvoiceRecords(row.SaleInvoiceID,'A');

          if (records) {
            const blob = await generateQRCodeBlob(records.invoiceDetails?.invoiceNo);
            if (!blob) return;
            console.log("Main Section:", records.invoiceDetails);
            console.log("Detail Section:", records.invoiceItems);
            SaleInvoiceService.SalesTaxInvoiceReport(records.invoiceDetails, records.invoiceItems, blob, 'download');
          } else {
            console.log("No records returned.");
          }
        };
       
        // ==================== PREVIEW B =======================
        const handleRedirectContractPreview2 = async (row) => {
          console.log(row);
          
          const records = await getFormattedInvoiceRecords(row.SaleInvoiceID,'B');
          const getPdfMargins = await securityService.CompanyIP();
          let PdfMargins = {
            Left: getPdfMargins.data.recordset[0].LeftMarginInches || 0.25,
            Right: getPdfMargins.data.recordset[0].RightMarginInches || 0.25,
            Top: getPdfMargins.data.recordset[0].TopMarginInches || 1.5,
            Bottom: getPdfMargins.data.recordset[0].BottomMarginInches || 0.25
          }
          console.log(PdfMargins)

          if (records) {
            const blob = await generateQRCodeBlob(records.invoiceDetails?.invoiceNo);
            if (!blob) return;
            console.log("Main Section:", records.invoiceDetails);
            console.log("Detail Section:", records.invoiceItems);
            SaleInvoiceService.generateSalesTaxInvoicePDF(records.invoiceDetails, records.invoiceItems, blob, 'download', PdfMargins);
          } else {
            console.log("No records returned.");
          }
        };

        // ==================== ✅ PREVIEW E =======================
        const handleRedirectContractPreviewE = async (row) => {
          console.log(row);

          const records = await getFormattedInvoiceRecords(row.SaleInvoiceID,'E');

          if (records) {
            const blob = await generateQRCodeBlob(records.invoiceDetails?.invoiceNo);
            if (!blob) return;
            console.log("Main Section:", records.invoiceDetails);
            console.log("Detail Section:", records.invoiceItems);
            // ✅ SalesTaxInvoiceReportE call ho raha hai — Preview A jaise same pattern
            SaleInvoiceService.SalesTaxInvoiceReportE(records.invoiceDetails, records.invoiceItems, blob, 'download');
          } else {
            console.log("No records returned.");
          }
        };

//  ======== DIALOG BOX FUNCTIOS SHOW/HIDE =========

const dialogRef = useRef(null);
const showDialog = (
  header = 'WARNING',
  title = ``,
  actions =['OK']) => {
  return new Promise((resolve) => {
  if (dialogRef.current) {
    dialogRef.current.destroy();
  }
  const okButtons = actions.map((action) => ({
    buttonModel: {
      content: action,
      cssClass: 'e-flat',
      isPrimary: action === 'OK',
    },
    click: (e) => {
      hideDialog();
      resolve(action);
    },
  }));
  dialogRef.current = new DialogInput({
    content: title =='' ? ()=>(<><span class="error-tooltip">Please select a row first!</span></>): ()=>(<div><br />{title}</div>),
    header:header,
    width:'340px',
    showButtons: true,
    buttons:okButtons,
    isModal: true,
  });
  dialogRef.current.show();
});
};
const hideDialog = () =>{
if (dialogRef.current) {
}
dialogRef.current.hide();
dialogRef.current.destroy();
dialogRef.current = null;
}

function showAlert({ heading, message, type = 'info', autoClose = 3000, position = 'top-right' }) {
  if (!heading || !message) {
    console.error('❌ showAlert requires both heading and message.');
    return;
  }

  toast[type](
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <div style={{ fontWeight: 'bold', fontSize: '15px', color: '#000', lineHeight: '1.3' }}>
        {heading}
      </div>
      <div style={{
        fontSize: '13px',
        color: '#000',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: '1.5',
      }}>
        {message}
      </div>
    </div>,
    {
      position,
      autoClose,
      style: {
        borderRadius: '6px',
        padding: '12px',
        height: 'auto',
        minHeight: '60px',
        width: '380px',
      },
    }
  );
}

    const dialogRefs = useRef(null);
    const showDialogs = (header,title,actions =['OK'] , inputid) => {
                return new Promise((resolve) => {
                if (dialogRefs.current) {
                  dialogRefs.current.destroy();
                }
                const okButtons = actions.map((action) => ({
                  buttonModel: {
                    content: action,
                    cssClass: 'e-flat',
                    isPrimary: action === 'OK',
                  },
                  click: async (e) => {
                    console.log(action);
                    if(action  == 'Download Template'){
                      await  ImportExcelService.downloadAndReadExcel('SaleInvoice');
                      hideDialogs()
                      resolve(action);
                    }else{
                      hideDialogs()
                      resolve(action);
                    }
                  },
                }));
                dialogRef.current = new DialogInput({
                  content: ()=>(<>{title}</>),
                  header:header,
                  width:'540px',
                  showButtons: true,
                  buttons:okButtons
                });
                dialogRef.current.show();
              });
              };
              const hideDialogs = () =>{
              if (dialogRef.current) {
              }
              dialogRef.current.hide();
              dialogRef.current.destroy();
              dialogRef.current = null;
              }

   const toolbarClicking =  async (grid , args , selectedRow , getListService,setDataSourceState)=>{
            console.log(grid , args)
        gridStore =  getListService

    console.log(selectedRow)

     if(args?.item?.id === 'ImportExcelList'){
        console.log(args)
        document.getElementById('ImportExcel').click()
      }
  
      if (args.name === "rowSelected" && selectedRow) {
        const { FBRSaleInvoiceDetailNo } = selectedRow;
        console.log(FBRSaleInvoiceDetailNo);
        const isPostedInvoice = FBRSaleInvoiceDetailNo && FBRSaleInvoiceDetailNo.trim().toUpperCase() !== "NULL";
        if (!isPostedInvoice) {
        } else {
        }
      }

      if(args?.item?.properties?.id == 'RowDelete'){
        if (selectedRow) {
          const { FBRSaleInvoiceDetailNo } = selectedRow;
          console.log(FBRSaleInvoiceDetailNo);
          const isPostedInvoice = FBRSaleInvoiceDetailNo && FBRSaleInvoiceDetailNo.trim().toUpperCase() !== "NULL";

          if (!isPostedInvoice) {
            const attemptDeleteInvoice = async (invoice) => {
              const userChoice = await showDialog(
                "Confirm Delete",
                "Are you sure you want to delete this invoice?",
                ["OK", "Cancel"]
              );

              if (userChoice === "Cancel") {
                await getListService();
                return;
              }

              const result = await SaleInvoiceService.deleteInvoice({SaleInvoiceID:invoice.SaleInvoiceID});
              console.log(result)
              if (result.status == "200" || result.statusText == 'OK') {
                showAlert({
                  heading: 'Success',
                  message: 'Invoice deleted successfully.',
                  type: 'success',
                  autoClose: 5000,
                  position: 'bottom-right',
                });
                getListService();
              } else {
                showAlert({
                  heading: 'Error',
                  message: 'Unable to delete invoice.',
                  type: 'error',
                  autoClose: 5000,
                  position: 'bottom-right',
                });
                await getListService();
              }
            };
            attemptDeleteInvoice(selectedRow)
          } else {
            showAlert({
              heading: 'Alert',
              message: 'CANNOT DELETE POSTED INVOICES.',
              type: 'info',
              autoClose: 5000,
              position: 'bottom-right',
            });
          }
        } else {
          showDialog()
        }
      }

      if(args?.item?.properties?.id == 'EditRow'){
        if (selectedRow) {
          const { FBRSaleInvoiceDetailNo } = selectedRow;
          console.log(FBRSaleInvoiceDetailNo);
          const isPostedInvoice = FBRSaleInvoiceDetailNo && FBRSaleInvoiceDetailNo.trim().toUpperCase() !== "NULL";
          if (!isPostedInvoice) {
            grid.startEdit()
          } else {
            showAlert({
              heading: 'Alert',
              message: 'CANNOT EDIT POSTED INVOICES.',
              type: 'info',
              autoClose: 5000,
              position: 'bottom-right',
            });
          }
        } else {
          showDialog()
        }
      }

      if(args?.item?.properties?.id == 'Add'){
        grid.addRecord()
      }

      if(args?.item?.properties?.id == 'SaleInvoicePreview'){
        if(selectedRow == undefined){
          showDialog()
        }else{
          handleRedirectContractPreview(selectedRow)
        }
      }

      if(args?.item?.properties?.id == 'SaleInvoicePreview2'){
        if(selectedRow == undefined){
          showDialog()
        }else{
          handleRedirectContractPreview2(selectedRow)
        }
      }

      // ✅ NEW — Preview E toolbar click handler
      if(args?.item?.properties?.id == 'SaleInvoicePreviewE'){
        if(selectedRow == undefined){
          showDialog()
        }else{
          handleRedirectContractPreviewE(selectedRow)
        }
      }

      if(args?.item?.properties?.id == 'PostData'){  
        console.log(args?.item?.properties?.id)
        document.getElementById("PostData").classList.add("Loading-Preview-PostData");

        if (selectedRow == undefined) {
          document.getElementById("PostData").classList.remove("Loading-Preview-PostData");
          showDialog();
          return;
        }

        const userChoice = await showDialog(
          "confirmation",
          "Are you sure you want to post this invoice?",
          ["OK", "Cancel"]
        );

        if (userChoice === "Cancel") {
          document.getElementById("PostData").classList.remove("Loading-Preview-PostData");
          await getListService();
          return;
        }

        const { FBRSaleInvoiceDetailNo, SaleInvoiceJSON, SaleInvoiceID } = selectedRow;
        console.log(FBRSaleInvoiceDetailNo)

        if (!FBRSaleInvoiceDetailNo || FBRSaleInvoiceDetailNo === "NULL") {
          try {
            let CompanyResponse = await SaleInvoiceService.getCompanyView()
            const parsedData = JSON.parse(SaleInvoiceJSON);
            console.log(parsedData)
            const response = props?.path == "/SaleInvoiceSandbox" ? await SaleInvoiceService.PostDataTesting(CompanyResponse.data.recordset[0].CompanyID ,parsedData) 
            : await SaleInvoiceService.PostData(CompanyResponse.data.recordset[0].CompanyID ,parsedData);
            console.log(response)
            document.getElementById("PostData").classList.remove("Loading-Preview-PostData");
            const validation = response?.data.validationResponse;
            const validInvoiceNumber = response?.data?.invoiceNumber;
            console.log(validation)

            if (validation?.statusCode === "00" && validation?.status === "Valid") {
              const invoiceNumber = validInvoiceNumber;
              const invoiceStatuses = validation.invoiceStatuses;

              const detailListResponse = await SaleInvoiceService.getSaleInvoiceForList(SaleInvoiceID , props?.path == "/SaleInvoiceSandbox" ? 0:1);
              const detailList = detailListResponse.data.recordset || []
              console.log(detailList)
              console.log(invoiceStatuses)

              const details = invoiceStatuses.map(status => {
                const index = parseInt(status.itemSNo, 10) - 1;
                const matchedDetail = detailList[index];
                document.getElementById("PostData").classList.remove("Loading-Preview-PostData");
                return {
                  SaleInvoiceDetailID: matchedDetail?.SaleInvoiceDetailID,
                  FBRSaleInvoiceDetailNo: status.invoiceNo,
                  
                };
              });
              
              const updatePayload = {
                FBRSaleInvoiceNo: invoiceNumber,
                SaleInvoiceID: selectedRow.SaleInvoiceID,
                PostingDate:moment().format('YYYY-MM-DD HH:mm:ss'),
                details
              };
              console.log(updatePayload)

              showAlert({
                heading: 'Alert',
                message: `Invoice ${invoiceNumber} posted successfully to FBR.`,
                type: 'info',
                autoClose: 5000,
                position: 'bottom-right',
              });

              console.log(updatePayload);
              let response = await SaleInvoiceService.updateInvoices(updatePayload);
              if(response.data?.success == true){
                getListService()
                showAlert({
                  heading: 'Alert',
                  message: `Invoices stored successfully.`,
                  type: 'info',
                  autoClose: 5000,
                  position: 'bottom-right',
                });
              }
            } else {
              document.getElementById("PostData").classList.remove("Loading-Preview-PostData");
              const invoiceStatuses = validation?.invoiceStatuses;

              if (invoiceStatuses && invoiceStatuses.length > 0) {
                invoiceStatuses.forEach((item) => {
                  showAlert({
                    heading: `FBR Error — Item ${item.itemSNo}`,
                    message: item.error || `Item ${item.itemSNo}: Validation failed`,
                    type: 'error',
                    autoClose: 15000,
                    position: 'bottom-right',
                  });
                });
              } else {
                showAlert({
                  heading: 'FBR Validation Failed',
                  message: validation?.error || 'Validation failed',
                  type: 'error',
                  autoClose: 10000,
                  position: 'bottom-right',
                });
              }
            }
          } catch (error) {
            document.getElementById("PostData").classList.remove("Loading-Preview-PostData");
            const fbrError = error?.response?.data?.error;
            const fbrMessage = error?.response?.data?.message;
            const errorText = fbrMessage || fbrError || 'No Response from FBR. Please try again.';
            showAlert({
              heading: 'FBR Connection Error',
              message: errorText,
              type: 'error',
              autoClose: 10000,
              position: 'bottom-right',
            });
          }
        } else {
          document.getElementById("PostData").classList.remove("Loading-Preview-PostData");
          showAlert({
            heading: 'Alert',
            message: `This sale invoice has already been posted to FBR`,
            type: 'info',
            autoClose: 10000,
            position: 'bottom-right',
          });
        }
      }
        }

      let DefaultSortedColumnSort ='Descending';

    let listDelete = [{ TableName:['SaleInvoiceDetail','SaleInvoice'] ,TableID:['SaleInvoiceID'] }];
    let deleteType = 'Hard'
    let filterColumns = [{ field: 'FBRSaleInvoiceDetailNo', operator: 'notequal', value: '' }];
    let filterColumnsSaleInvoice = [{ field: 'FBRSaleInvoiceDetailNo', operator: 'equal', value: '' }];
    let groupColumns = ['SaleInvoiceID'];
    let gridEditSettingMode = 'Dialog';
    let gridEditSettingHeaderTemplate = '<p></p>';
    let gridSumColumns = [
      "quantity",
      "valueSalesExcludingST",
      "fixedNotifiedValueOrRetailPrice",
      "salesTaxWithheldAtSource",
      "fedPayable",
      "discount",
      "totalValues",
      'salesTaxApplicable'
    ];

    let gridStore;

    let btn = { Id:'ImportExcel', Content:'Import Excel', BgColor:'#2c842d', Color:'#f4f4f4',
      Input:{
        Route:'ImportExcel',
        Title:'Import Excel', 
        Security:props?.path == "/SaleInvoiceSandbox" ? `Sale Invoice Sandbox` :`Sale Invoice`,
        Width:'98vw',
        Height:'1000px',
        onClosing: async (e)=>{
          console.log(gridStore)
          gridStore();
        }
      }
    }

  const rowDataBound = (args) => {
    if (args?.data?.isDuplicateReferenceNo) {
      args.row.classList.add("dup-text-red-duplicate");
      const tooltip = new TooltipComponent({
        content: "Duplicate Reference No",
        opensOn: "Hover",
        position: "TopCenter",
        showTipPointer: true,
        cssClass: "dup-tooltip",
        offsetX: 20,
        mouseTrail: true,
        animation: {
          open: { effect: "FadeIn", duration: 150 },
          close: { effect: "FadeOut", duration: 100 },
        },
        openDelay: 40,
        closeDelay: 50,
      });
      tooltip.appendTo(args.row);
    }
  };
  
    return (
      <>
      <ListButtonPopupList 
                key={1}
                Id={btn.Id}
                Route={btn?.Input?.Route}
                Security={btn?.Input?.Security}
                OnClosed={btn?.Input?.onClosing}
                Title={btn?.Content}
                InputTitle={btn?.Input?.Title}
                Width={btn?.Input?.Width}
                Height={btn?.Input?.Width}
                SelectedRow={{}}
                BgColor={btn?.BgColor}
                Color={btn?.Color}
                inputType={'SaleInvoice'}
                dataListSource={{dataSource:{type:'Function',source:()=>
                   SaleInvoiceService.getForList(
                    0 , props?.path == "/SaleInvoiceSandbox" ? 0 : 1
                   )}}}
                  isSendBox={props?.path == "/SaleInvoiceSandbox" ?true :false}
              />
             <ToastContainer 
              theme="light"
              style={{ width: '400px' }}
              toastStyle={{
                backgroundColor: '#ffffff',
                color: '#000000',
                border: '1px solid #ccc',
                borderRadius: '6px',
                padding: '12px',
                height: 'auto',
                minHeight: '60px',
                boxSizing: 'border-box',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
              }}
            />
        <DynamicInputList
        Id='SaleInvoice'
      
        ListTitle= {props?.path == "/SaleInvoiceSandbox" ? 'Sale  Invoice - Sandbox (Testing) - List' :props?.path == "/SaleInvoicePosted" ? 'Sale Invoice - POSTED - List' : 'Sale Invoice - Production - List'}
        ColumnsList={columns}
        GridDataSource= {[{
            DataSourceType: 'Function',
            DataSource: ()=> SaleInvoiceService.getSaleInvoiceForList(0 , props?.path == "/SaleInvoiceSandbox" ? 0:1)
        }]}
        DefaultSortedColumnName={'SaleInvoiceID'}
        GridDialog={[{
            DialogType:'Self',
            Dialog:<InvoiceAdd  GridID ='SaleInvoice' sendDetails={getDetail} isTesting={props?.path == "/SaleInvoiceSandbox" }/>
        }]}
        ListActionComplete={listActionComplete}
        ToolbarClicking={toolbarClicking}
        rowDataBound={rowDataBound}
            AllowTemplate={allowTemplate}
            ToolbarOption={props?.path == "/SaleInvoicePosted" ? PostedToolbarOptions : toolbarOptions}
            ListSecurity={ListSecurity}
            AddSecurity={AddSecurity}
            EditSecurity={props?.path == "/SaleInvoicePosted" ?  false : EditSecurity}
            DeleteSecurity={DeleteSecurity}
            FilterColumns={props?.path == "/SaleInvoicePosted" ? filterColumns : props?.path == "/SaleInvoice" ? filterColumnsSaleInvoice : []}
            GroupColumns={groupColumns} 
            ListDelete={listDelete}
            DeleteType={deleteType} 
            GridSumColumns={gridSumColumns}
            AllowGridSum={allowGridSum}
            IsDialog={isDialog}
            {...props}
        ></DynamicInputList>
      </>
    );
}

export default SaleInvoiceInput;